<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="evgSkuPlatformCode"
      cell-class-name="align-top"
      auto-resize
      highlight-hover-row
      :height="650"
      :data="tableData"
      :loading="loading"
      :columns="tableColumns"
      :toolbar-config="tableToolbar"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:displayImage="{ row }">
        <el-image
          :src="$osscdn(row.defaultImageUrl) || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            $osscdn(row.defaultImageUrl) || '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displaySkuName="{ row }">
        <TableLabel label="SKU" :value="row.evgSkuNo" primary />
        <TableLabel :value="row.goodsName" />
        <TableLabel :value="row.goodsNameEn" />
        <TableLabel label="UPC" :value="row.eanCode" />
      </template>

      <template v-slot:displaySalesTitle="{ row }">
        <TableLabel :value="row.salesTitle" />
        <TableLabel
          label="渠道Item号"
          labelKey="table_label_channelItemNo"
          :value="row.channelItemNo"
          primary
        />
        <TableLabel
          label="渠道款号"
          labelKey="table_label_channelSkuNo"
          :value="row.channelSkuNo"
          primary
        />
        <TableLabel
          label="渠道条码号"
          labelKey="table_label_channelEanNo"
          :value="row.channelEanNo"
          primary
        />
        <TableLabel
          label="渠道产品GTIN号"
          labelKey="table_label_eachGtinNo"
          :value="row.eachGtinNo"
        />
        <TableLabel
          label="渠道内包装GTIN号"
          labelKey="table_label_innerPackGtinNo"
          :value="row.innerPackGtinNo"
        />
        <TableLabel
          label="渠道箱包装GTIN号"
          labelKey="table_label_caseGtinNo"
          :value="row.caseGtinNo"
        />
      </template>

      <template v-slot:displayPlatform="{ row }">
        <TableLabel
          label="渠道名称"
          labelKey="table_label_platformName"
          :value="row.platformName"
        />
        <TableLabel
          label="BRAND"
          labelKey="table_label_brandName"
          :value="row.brandName"
        />
        <TableLabel
          label="销售渠道"
          labelKey="table_label_platformType"
          :value="row.v_platformType"
        />
        <TableLabel label="METHOD" labelKey="table_label_evgSellType">
          <el-tag
            v-if="row.v_evgSellType"
            size="mini"
            :type="
              row.evgSellType === 'B'
                ? ''
                : row.evgSellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_evgSellType }}
          </el-tag>
        </TableLabel>
        <TableLabel label="STATUS" labelKey="table_label_evgSkuPlatformStatus">
          <el-tag
            v-if="row.v_evgSkuPlatformStatus"
            size="mini"
            :type="
              row.evgSkuPlatformStatus === 'Y'
                ? 'success'
                : row.evgSkuPlatformStatus === 'S'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_evgSkuPlatformStatus }}
          </el-tag>
        </TableLabel>
      </template>

      <template v-slot:displayWarehouse="{ row }">
        <TableLabel
          label="发货仓库"
          labelKey="table_label_ecomWarehouseName"
          :value="row.ecomWarehouseName"
        />
        <TableLabel
          label="仓库SKU号"
          labelKey="table_label_whSkuNo"
          :value="row.whSkuNo"
        />
        <TableLabel
          label="最小出货"
          labelKey="table_label_sellableEach"
          :value="`${row.sellableEachQty || 0} ${row.v_sellableEachUnit || ''}`"
          primary
        />
      </template>

      <template v-slot:displayProductUnit="{ row }">
        <TableLabel
          label="单位"
          labelKey="label_key_unit"
          :value="row.v_skuPackSize"
        />
        <TableLabel
          label="入数"
          labelKey="label_key_qty"
          :value="row.specInUnitQty"
        />
      </template>

      <template v-slot:displayFactory="{ row }">
        <TableLabel
          label="NC"
          labelKey="table_label_ncNo"
          :value="row.ncNo"
          primary
        />
        <TableLabel :value="row.scmName" />
      </template>

      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
      format,
    }
  },
  computed: {},
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
